// extracted by mini-css-extract-plugin
export var divider = "_47-0";
export var dividerText = "_47-1";